import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { Typography, Box, Paper, Divider, Grid } from '@material-ui/core';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import {
   mock_totalpoint,
   mock_graph,
   mock_table,
} from '../../../mockdata/dashboard/mock-graph-3';
import { makeStyles } from '@material-ui/core/styles';
import SummaryBoxesTotalPoint from '../../../components/Dashboard/SummaryBox/TotalPoint';
import FilterYear from '../../../components/Dashboard/Filter/Year';
import Filter from '../../../components/Dashboard/Filter/Date';
import MaterialTable from 'material-table';
import { tableIcons } from '../../../configs/ui/TableConfig';
import EmptyChart from '../../../components/Dashboard/Chart/EmptyChart';
import CircularProgress from '@material-ui/core/CircularProgress';
import DownloadPDFButton from '../../../components/Dashboard/Button/DownloadPDF';
import { useLocation } from 'react-router-dom';
import FileSaver from 'file-saver';
import DownloadExcelButton from '../../../components/Dashboard/Button/DownloadExcel';

let mock = false;

const useStyles = makeStyles((theme) => ({
   loading: {
      height: '434px',
      width: '100%',
      backgroundColor: '#F2F2F2',
      borderRadius: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
   },
   graphsContainer: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
   },
   tablesContainer: {
      backgroundColor: 'white',
      height: '100%',
   },
}));

const ProjectDepartment = () => {
   const classes = useStyles();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [isLoadingGraph, setIsLoadingGraph] = useState(false);
   const [isLoadingMultiTable, setIsLoadingMultiTable] = useState(false);
   const [isLoadingExcel, setIsLoadingExcel] = useState(false);
   const [MultiChartData, setMultiChartData] = useState([]);
   const [MultiTable, setMultiTable] = useState(null);
   const [totalPoint, setTotalPoint] = useState();
   const [isLoadingSummaryBoxes, setIsLoadingSummaryBoxes] = useState();
   const [isShowGraph, setIsShowGraph] = useState(false);
   const [filtersData, setFiltersData] = useState();
   const location = useLocation();
   const getChartsOptionsDefault = () => {
      let option = {
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               // Use axis to trigger tooltip
               type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
            },
         },
         legend: {},
         grid: {
            top: '10%',
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true,
         },
         xAxis: {
            type: 'value',
         },
         yAxis: {
            type: 'category',
            data: null,
            axisLabel: {
               formatter: (value) => JSON.parse(value).shortName,
            },
         },
         series: [
            {
               color: '',
               stack: 'total',
               type: 'bar',
               data: null,
            },
            {
               color: '',
               stack: 'total',
               type: 'bar',
               data: null,
            },
         ],
      };
      return option;
   };
   const onChangeYear = (year) => {
      let payload = { year };
      setIsLoadingSummaryBoxes(true);
      Axios.get('/GSB/dashboard/dashboard/GetTotalPoint', { params: payload })
         .then((resp) => {
            setTotalPoint({
               ...resp.data,
               year,
            });
            // enqueueSnackbar('ดึงข้อมูลคะแนนสำเร็จ', { variant: 'success' });
         })
         .catch((e) => {
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(e.response.data.errorAppMessageTh, {
                  variant: 'error',
               });
            } else {
               console.error('site error');
            }
         })
         .finally(() => {
            setIsLoadingSummaryBoxes(false);
         });
   };
   const onFiltersSubmit = (filters) => {
      setFiltersData(filters);
      let payload = {
         startDate: filters.startDateString,
         endDate: filters.endDateString,
      };
      if (mock) {
         setIsLoadingGraph(true);
         setTimeout(() => {
            setIsLoadingGraph(false);
            setIsShowGraph(true);
            setMultiChartData(mock_graph.graph);
         }, 1000);
      } else {
         setIsLoadingGraph(true);
         Axios.get('/GSB/dashboard/dashboard/GetBankWalletGraph', {
            params: payload,
         })
            .then((resp) => {
               setIsShowGraph(true);
               setMultiChartData(resp.data.graph);
               // enqueueSnackbar('ดึงข้อมูลกราฟสำเร็จ', { variant: 'success' });
            })
            .catch((e) => {
               setMultiChartData(null);
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(response.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else console.error('site error');
            })
            .finally(() => {
               setIsLoadingGraph(false);
            });
      }
   };
   const costFormat = (value) => {
      return value && new Intl.NumberFormat().format(value);
   };
   const mapOptions = (data) => {
      let yAxisLabels = data.bankWallets.map((el) =>
         JSON.stringify({ shortName: el.shortNameTh, fullName: el.nameTh }),
      );
      let remainPoints = data.bankWallets.map((el) => el.remainPoints);
      let totalUsedPoints = data.bankWallets.map((el) => el.totalUsedPoints);
      let options = getChartsOptionsDefault();
      options.tooltip.formatter = (params) => {
         let html = `<div>${JSON.parse(params[0].name).fullName}</div>`;
         params.forEach((el, i) => {
            html += `<div>${el.marker} ${el.seriesName} ${costFormat(
               el.value,
            )}</div>`;
         });
         html += `<div>จำนวนคะแนน P ทั้งหมด ${costFormat(
            params[0].value + params[1].value,
         )}</div>`;
         return html;
      };
      options.yAxis.data = yAxisLabels;
      options.series[0].data = remainPoints;
      options.series[0].name = 'จำนวนคะแนน P คงเหลือ';
      options.series[0].color = '#67B0DA';
      options.series[1].data = totalUsedPoints;
      options.series[1].name = 'จำนวนคะแนน P ที่ใช้ไป';
      options.series[1].color = '#F383BB';
      return options;
   };
   useEffect(() => {
      getMultiTable();
   }, []);

   const getMultiTable = () => {
      if (mock) {
         setTimeout(() => {
            setMultiTable(mock_table.lists);
         }, 100);
      } else {
         setIsLoadingMultiTable(true);
         Axios.get('/GSB/dashboard/dashboard/GetTopBankWalletUsage')
            .then((resp) => {
               setMultiTable(resp.data.lists);
               // enqueueSnackbar('ดึงข้อมูลตารางสำเร็จ', { variant: 'success' });
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingMultiTable(false);
            });
      }
   };
   const handleDownloadExcel = () => {
      setIsLoadingExcel(true);
      Axios.get(`/GSB/dashboard/dashboard/GetTopBankWalletUsage`, {
         responseType: 'blob',
         params: {
            isGenerateReport: true,
         },
      })
         .then((response) => {
            setIsLoadingExcel(false);
            FileSaver.saveAs(
               new Blob([response.data]),
               'แสดงคะแนนโครงการแบ่งตามสังกัด.xlsx',
            );
         })
         .catch((err) => {
            enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
               variant: 'error',
            });
         });
   };
   return (
      <div>
         <Box margin={'10px 0px'} textAlign={'end'}>
            <DownloadPDFButton
               disabled={isLoadingGraph || isLoadingMultiTable}
               to={() => {
                  localStorage.setItem(
                     'report',
                     JSON.stringify({
                        totalPoint,
                        filtersData,
                        MultiChartData,
                        MultiTable,
                     }),
                  );
                  return {
                     pathname: location.pathname + '/report',
                  };
               }}
            />
         </Box>
         <Paper>
            <Box padding={'10px'}>
               <Typography variant='h5'>
                  แสดงคะแนนโครงการแบ่งตามสังกัด
               </Typography>
               <Box>
                  <Grid xs={2}>
                     <FilterYear
                        onChangeYear={onChangeYear}
                        defaultSubmitFirstParams
                     />
                  </Grid>
                  <Box marginTop={'10px'}>
                     <SummaryBoxesTotalPoint
                        totalPoint={totalPoint}
                        isLoading={isLoadingSummaryBoxes}
                     />
                  </Box>
               </Box>
               <Box marginTop={'10px'}>
                  <Filter
                     isLoading={isLoadingGraph}
                     onSubmit={onFiltersSubmit}
                     defaultSubmitFirstParams
                  />
               </Box>
            </Box>
            <Box padding={'10px'}>
               {isShowGraph ? (
                  <Box className={classes.graphsContainer}>
                     {MultiChartData &&
                        MultiChartData.map((item, index) => (
                           <Box key={index} width={'50%'}>
                              <Box fontSize={24} fontWeight={'bold'}>
                                 {item.graphName}
                              </Box>
                              <ReactECharts
                                 option={mapOptions(item)}
                                 style={{ height: 300, width: '100%' }}
                              />
                           </Box>
                        ))}
                  </Box>
               ) : (
                  <EmptyChart
                     text={'ไม่มีข้อมูล, โปรดระบุตัวกรองด้านบนเพื่อแสดงกราฟ'}
                     show={true}
                     height={300}
                  />
               )}
            </Box>
            <Divider variant='middle' />
            <Box marginTop={'10px'} padding={'10px'}>
               <Box textAlign={'end'}>
                  <DownloadExcelButton
                     isLoading={isLoadingExcel}
                     onClick={handleDownloadExcel}
                  />
               </Box>
               {isLoadingMultiTable ? (
                  <div className={classes.loading}>
                     <CircularProgress size={20} />
                  </div>
               ) : (
                  MultiTable &&
                  MultiTable.map((item, index) => (
                     <Box
                        className={classes.tablesContainer}
                        key={index}
                        marginRight={
                           index !== MultiTable.length - 1 ? '10px' : 0
                        }
                     >
                        <Box
                           minHeight={50}
                           fontSize={24}
                           fontWeight={'bold'}
                           display={'flex'}
                           alignItems={'center'}
                        >
                           {item.listName}
                        </Box>
                        <MaterialTable
                           columns={[
                              {
                                 field: 'seq',
                                 title: 'ลำดับ',
                                 sorting: false,
                                 width: 10,
                              },
                              {
                                 field: 'orgEmployeeId',
                                 title: 'รหัสพนักงาน',
                                 sorting: false,
                              },
                              {
                                 field: 'employeeName',
                                 title: 'ชื่อพนักงาน',
                                 sorting: false,
                              },
                              {
                                 field: 'divisionName',
                                 title: 'ชื่อสังกัด',
                                 sorting: false,
                              },
                              {
                                 field: 'positionName',
                                 title: 'ตำแหน่ง',
                                 sorting: false,
                              },
                              {
                                 field: 'numberofUsage',
                                 title: 'จำนวนครั้ง',
                                 sorting: false,
                                 align: 'right',
                              },
                              {
                                 field: 'totalUsagePoints',
                                 title: 'P ที่ใช้',
                                 sorting: false,
                                 align: 'right',
                              },
                              {
                                 field: 'totalReceivedPoints',
                                 title: 'P ที่ได้รับ',
                                 sorting: false,
                                 align: 'right',
                              },
                           ]}
                           data={item.bankWalletUsages}
                           options={{
                              paging: false,
                              showTitle: false,
                              headerStyle: {
                                 fontWeight: 'bold',
                                 backgroundColor: '#F6F6F6',
                              },
                              actionsColumnIndex: -1,
                              addRowPosition: 'first',
                              actionsCellStyle: {
                                 color: '#ccc',
                              },
                              padding: 'dense',
                              pageSize: 10,
                              search: false,
                              toolbar: false,
                              draggable: false,
                           }}
                           localization={{
                              body: {
                                 editRow: {
                                    deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                                 },
                              },
                              header: { actions: 'ตัวจัดการ' },
                           }}
                           icons={tableIcons}
                        />
                     </Box>
                  ))
               )}
            </Box>
         </Paper>
      </div>
   );
};

export default ProjectDepartment;
